// ABOUTME: Pure cart-line arithmetic — line quantity, unit amount parsing, line/cart totals.
// ABOUTME: Mirrors backend services/selection_ops.py semantics: entries without `quantity` count as 1.

/** Ceiling on a single line's quantity. Mirrors `MAX_LINE_QUANTITY` in the backend's
 *  services/selection_ops.py — the manual + button must stop where the server would clamp anyway,
 *  or the row shows a count the agent's own view of the bag does not have. */
export const MAX_LINE_QUANTITY = 24;

/** Quantity of a cart line; entries predating the field (or garbage) count as 1. */
export const itemQuantity = (item) => {
  const q = Number(item?.quantity);
  return Number.isFinite(q) && q >= 1 ? Math.floor(q) : 1;
};

/** Unit amount: prefer the normalized numeric `price.amount`, fall back to stripping a display
 *  string ("£2,895" → 2895). Unparseable prices contribute 0, same as the legacy subtotal. */
export const itemUnitAmount = (item) => {
  if (typeof item?.price?.amount === 'number') return item.price.amount;
  const amount = Number(
    String(item?.price_info?.price ?? item?.price?.display ?? '0').replace(/[^0-9.-]+/g, '')
  );
  return Number.isNaN(amount) ? 0 : amount;
};

/** A line's total: unit price × quantity. */
export const lineTotalAmount = (item) => itemUnitAmount(item) * itemQuantity(item);

/** Bag subtotal across all lines (quantity-aware). */
export const cartTotalAmount = (items) =>
  (Array.isArray(items) ? items : []).reduce((total, item) => total + lineTotalAmount(item), 0);

/** Total UNITS in the bag (2 lines ×2 each → 4) — drives the header count and rail badge. */
export const cartUnitCount = (items) =>
  (Array.isArray(items) ? items : []).reduce((total, item) => total + itemQuantity(item), 0);
